<template>
    <div class="panel">
        <div class="color-container" v-for="color in colors" :id="color.id + '_container'" :class="{ active: isSelected(color) }" @click="selectColor(color)" :style=doColorPlacement(color)>
        <transition name="fade" appear>
                <img :id="color.id" :src="color.offFile" :style=doColorPlacement(color)>
        </transition>
        </div>
    </div>
</template>

<script>
    import response from '@/stores/response.js'

    export default {
        name: 'Color_panel',
        created: function () {
            var self = this;
            self.$root.$once('next-panel', function() {
                self.saveData();
            });
            CodeBaby.jQuery('.codebaby-stt-button:visible').hide();
            CodeBaby.jQuery('.no-nlp').hide();
        },
        data: function() {
            return {
                response: response,
                selectedColor: null,
                colors: [
                    {
                        name: "Peach",
                        id: "color-1",
                        offFile: require('@/assets/images/color1.png'),
                        onFile: require('@/assets/images/color1_on.png'),
                        xPos: 30,
                        yPos: 60
                    },
                    {
                        name: "Yellow",
                        id: "color-2",
                        offFile: require('@/assets/images/color2.png'),
                        onFile: require('@/assets/images/color2_on.png'),
                        xPos: 155,
                        yPos: 30

                    },
                    {
                        name: "Olive",
                        id: "color-3",
                        offFile: require('@/assets/images/color3.png'),
                        onFile: require('@/assets/images/color3_on.png'),
                        xPos: 265,
                        yPos: 60
                    },
                    {
                        name: "Red",
                        id: "color-4",
                        offFile: require('@/assets/images/color4.png'),
                        onFile: require('@/assets/images/color4_on.png'),
                        xPos: 0,
                        yPos: 185
                    },
                    {
                        name: "Light Blue",
                        id: "color-5",
                        offFile: require('@/assets/images/color5.png'),
                        onFile: require('@/assets/images/color5_on.png'),
                        xPos: 235,
                        yPos: 185
                    },
                    {
                        name: "Violet",
                        id: "color-6",
                        offFile: require('@/assets/images/color6.png'),
                        onFile: require('@/assets/images/color6_on.png'),
                        xPos: 30,
                        yPos: 295
                    },
                    {
                        name: "Gray",
                        id: "color-7",
                        offFile: require('@/assets/images/color7.png'),
                        onFile: require('@/assets/images/color7_on.png'),
                        xPos: 155,
                        yPos: 265
                    },
                    {
                        name: "Dark Blue",
                        id: "color-8",
                        offFile: require('@/assets/images/color8.png'),
                        onFile: require('@/assets/images/color8_on.png'),
                        xPos: 265,
                        yPos: 295
                    }
                ]
            };
        },
        methods: {
            isSelected: function (color) {
                return (color == this.selectedColor);
            },
            selectColor: function (color) {
                var activeContainerID = CodeBaby.jQuery('.color-container.active').attr('id');
                var activeColorIndex = (activeContainerID) ? this.findObjAttrInArray(this.colors, 'id', activeContainerID.substring(0, activeContainerID.indexOf("_"))) : null;
                var activeColor = (activeColorIndex !== null) ? this.colors[activeColorIndex] : null;
                var activeColorOffFile = (activeColor !== null) ? activeColor.offFile : null;
                if (activeColorOffFile !== null) CodeBaby.jQuery('#' + activeColor.id).attr({src: activeColorOffFile});
                this.selectedColor = color;
                CodeBaby.jQuery("#" + color.id).attr({src: color.onFile})
            },
            findObjAttrInArray: function (arrayName, searchKey, searchValue) {
                for(var i=0; i < arrayName.length; i++) {
                    if (arrayName[i][searchKey] === searchValue) return i;
                }
            },
            doColorPlacement: function (color) {
                var baseOffsetTop = 75;
                var baseOffsetLeft = 125;
                return { left: color.xPos + baseOffsetLeft + 'px', top: baseOffsetTop + color.yPos + 'px' }
            },
            saveData: function () {
                this.response[(this.$parent.panelState.curPanel - 1)].answer = this.selectedColor.name;
            }            
        }
    }
</script>
<style scoped lang="stylus">
.panel
    text-align: center
    background-color: #ccc !important
    .fade-enter-active, .fade-leave-active 
        transition: opacity 1s
    .fade-enter, .fade-leave-to
        opacity: 0
    .color-container
        position: absolute
        top: 0
        left: 0
        margin: 0
        padding: 0
        cursor: pointer
</style>